import React, { useState } from 'react';
import {
    Container,
    Typography,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Paper,
    Grid,
    Box,
    TextField,
    IconButton
} from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { GetActivitiesDataAPI, GetActivityDataAPI, GetBonosDataAPI, GetGradeActivitiesDataAPI, GetGruopDataAPI, GetPointsDataAPI } from '../../Conections/AcademicConection';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

// Datos de ejemplo
const actividadEjemplo = {
    id: '0',
    nombre: "",
    descripcion: "",
    peso: 0,
    fecha: "",
    activa: true
};

const grupoEjemplo = {
    id: '',
    nombre: '',
    descripcion: '',
    estado: true,
};

function GradeShow() {

    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();


    const [grupo, setGrupo] = useState(grupoEjemplo);
    const [actividad, setActividad] = useState(actividadEjemplo);
    const [busqueda, setBusqueda] = useState('');
    const [actividadTitle, setActividadTitle] = useState("");

    const [subactividadesEjemplo, setSubactividadesEjemplo] = useState([]);
    const [puntosEjemplo, setPuntosEjemplo] = useState([]);
    const [bonosEjemplo, setBonosEjemplo] = useState([]);
    const [notasEjemplo, setNotasEjemplo] = useState([]);

    // Datos para la gráfica de barras
    const datosGrafica = [
        { rango: '0-5', cantidad: notasEjemplo.filter(e => e.definitiva >= 0 && e.definitiva < 5).length },
        { rango: '5-10', cantidad: notasEjemplo.filter(e => e.definitiva >= 5 && e.definitiva < 10).length },
        { rango: '10-15', cantidad: notasEjemplo.filter(e => e.definitiva >= 10 && e.definitiva < 15).length },
        { rango: '15-20', cantidad: notasEjemplo.filter(e => e.definitiva >= 15 && e.definitiva < 20).length },
        { rango: '20-25', cantidad: notasEjemplo.filter(e => e.definitiva >= 20 && e.definitiva < 25).length },
        { rango: '25-30', cantidad: notasEjemplo.filter(e => e.definitiva >= 25 && e.definitiva < 30).length },
        { rango: '30-35', cantidad: notasEjemplo.filter(e => e.definitiva >= 30 && e.definitiva < 35).length },
        { rango: '35-40', cantidad: notasEjemplo.filter(e => e.definitiva >= 35 && e.definitiva < 40).length },
        { rango: '40-45', cantidad: notasEjemplo.filter(e => e.definitiva >= 40 && e.definitiva < 45).length },
        { rango: '45-50', cantidad: notasEjemplo.filter(e => e.definitiva >= 45 && e.definitiva <= 50).length },
    ];

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/showactivity/:id");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
                else {
                    let Activity = await GetActivityDataAPI(getToken(), getCompany(), params["activity"]);
                    let Activities = await GetActivitiesDataAPI(getToken(), getCompany(), Activity["group"], params["activity"]);
                    let Points = await GetPointsDataAPI(getToken(), getCompany(), params["activity"]);
                    let Bonos = await GetBonosDataAPI(getToken(), getCompany(), params["activity"]);
                    let ListGrades = await GetGradeActivitiesDataAPI(getToken(), getCompany(), Activity["group"], params["activity"]);
                    let Gruop = await GetGruopDataAPI(getToken(), getCompany(), Activity["group"]);
                    let grupoC = grupo;
                    grupoC["id"] = Gruop["gruop"]["id"];
                    grupoC["nombre"] = Gruop["gruop"]["name"];
                    grupoC["descripcion"] = Gruop["gruop"]["descripcion"];
                    grupoC["estado"] = Gruop["gruop"]["show"] === 1;
                    setGrupo(grupoC);

                    console.log(ListGrades);
                    setNotasEjemplo(ListGrades);


                    let actividadChange = actividad;
                    actividadChange["id"] = Activity["id"];
                    setActividadTitle(Activity["name"]);
                    actividadChange["nombre"] = Activity["name"];
                    actividadChange["descripcion"] = Activity["description"];
                    actividadChange["peso"] = Activity["weigth"];
                    actividadChange["fecha"] = Activity["date"];
                    actividadChange["activa"] = Activity["show"] === 1;
                    setActividad(actividadChange);


                    const listActivities = Activities.map(Activity => ({
                        id: Activity.id,
                        nombre: Activity.name,
                        peso: Activity.weigth,
                        fecha: Activity.date,
                        activa: (Activity.show === 1)
                    }));
                    setSubactividadesEjemplo(listActivities);

                    const listPoint = Points.map(Point => ({
                        id: Point.id,
                        nombre: Point.text,
                        peso: Point.weigth,
                    }));
                    setPuntosEjemplo(listPoint);

                    const listBono = Bonos.map(Bono => ({
                        id: Bono.id,
                        nombre: Bono.name,
                        peso: Bono.value,
                        activo: Bono.show === 1
                    }));
                    setBonosEjemplo(listBono);

                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [params, actividad, getCompany, getToken, goTo, actividadTitle]);

    const filtrarEstudiantes = () => {
        return notasEjemplo.filter(estudiante =>
            String(estudiante.codigo).toLowerCase().includes(busqueda.toLowerCase()) ||
            estudiante.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
            String(estudiante.apellido).toLowerCase().includes(busqueda.toLowerCase())
        );
    };

    const handleSubirNotas = () => {
        goTo(`/academic/gradeup/${actividad.id}`);
    };

    const handleSubirNotasPorGrupo = () => {
        goTo(`/academic/gradeupone/${actividad.id}`);
    };

    const handleGrupo = () => {
        goTo("/academic/showgroup/" + grupo.id);
    };

    const handlePrincipal = () => {
        goTo("/academic/showactivity/" + actividad.id);
    };

    const PuntoCell = ({ punto }) => {
        const [hover, setHover] = useState(false);

        return (
            <TableCell
                align="center"
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                sx={{ position: "relative" }}
            >
                {punto.nota}
                {hover && (
                    <span
                        style={{
                            position: "absolute",
                            bottom: "100%",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "gray",
                            color: "white",
                            padding: "5px",
                            borderRadius: "5px",
                            fontSize: "16px",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Razon: {punto.razon}
                    </span>
                )}
            </TableCell>
        );
    };


    return (
        <Container maxWidth="lg">
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ my: 4 }}>
                Notas de la Actividad
            </Typography>

            <Grid container spacing={3} direction="column">
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                <IconButton onClick={() => handleGrupo()} color="primary">
                                    <PeopleOutlineIcon />
                                </IconButton>
                                Datos de la Grupo
                            </Typography>
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {grupo.nombre}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Descripción:</strong> {grupo.descripcion}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                <IconButton onClick={() => handlePrincipal()} color="primary">
                                    <ArrowBackIosIcon />
                                </IconButton>
                                Datos de la Actividad
                            </Typography>
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {actividad.nombre}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Descripción:</strong> {actividad.descripcion}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Peso:</strong> {actividad.peso}%
                            </Typography>
                            <Typography variant="body1">
                                <strong>fecha:</strong> {actividad.fecha}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Estado:</strong>{' '}
                                <span style={{ color: actividad.activa ? 'green' : 'red', fontWeight: 'bold' }}>
                                    {actividad.activa ? 'Activa' : 'Inactiva'}
                                </span>
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleSubirNotas}
                                    sx={{ mt: 2 }}
                                >
                                    Subir notas
                                </Button>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleSubirNotasPorGrupo}
                                    sx={{ mt: 2 }}
                                >
                                    Subir notas por grupos
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Distribución de Notas
                            </Typography>
                            <ResponsiveContainer width="100%" height={300}>
                                <BarChart data={datosGrafica}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="rango" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="cantidad" fill="#8884d8" />
                                </BarChart>
                            </ResponsiveContainer>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Detalle de Notas
                            </Typography>
                            <TextField
                                fullWidth
                                label="Buscar estudiante"
                                variant="outlined"
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <Box sx={{ overflow: 'auto', maxWidth: '100%' }}>
                                <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
                                    <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ minWidth: 100, position: 'sticky', left: 0, background: 'white', zIndex: 1000 }}>Código</TableCell>
                                                    <TableCell sx={{ minWidth: 150, position: 'sticky', left: 100, background: 'white', zIndex: 1000 }}>Nombre</TableCell>
                                                    <TableCell sx={{ minWidth: 150, position: 'sticky', left: 250, background: 'white', zIndex: 1000 }}>Apellido</TableCell>
                                                    {subactividadesEjemplo.map(sub => (
                                                        <TableCell key={sub.id} align="center" sx={{ backgroundColor: sub.activa ? 'LightGreen' : 'Salmon', minWidth: 120 }}>
                                                            {sub.nombre} ({sub.peso})<br />[50]
                                                        </TableCell>
                                                    ))}
                                                    {puntosEjemplo.map(punto => (
                                                        <TableCell key={punto.id} align="center" sx={{ minWidth: 120 }}>
                                                            {punto.nombre} ({punto.peso})<br />[100]
                                                        </TableCell>
                                                    ))}
                                                    {bonosEjemplo.map(bono => (
                                                        <TableCell key={bono.id} align="center" sx={{ backgroundColor: 'lightblue', minWidth: 120 }}>
                                                            {bono.nombre} ({bono.peso})
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center" sx={{ backgroundColor: 'LightGray', minWidth: 120 }}>Definitiva<br />[50]</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {filtrarEstudiantes().map((estudiante) => (
                                                    <TableRow key={estudiante.id}>
                                                        <TableCell sx={{ position: 'sticky', left: 0, background: 'white', zIndex: 1 }}>{estudiante.codigo}</TableCell>
                                                        <TableCell sx={{ position: 'sticky', left: 100, background: 'white', zIndex: 1 }}>{estudiante.nombre}</TableCell>
                                                        <TableCell sx={{ position: 'sticky', left: 250, background: 'white', zIndex: 1 }}>{estudiante.apellido}</TableCell>
                                                        {estudiante.subactividades.map(sub => (
                                                            <TableCell key={sub.id} align="center" sx={{ backgroundColor: sub.show ? 'LightGreen' : 'Salmon' }} >{sub.nota}</TableCell>
                                                        ))}
                                                        {estudiante.puntos.map(punto => (
                                                            <PuntoCell key={punto.id} punto={punto} />
                                                        ))}
                                                        {estudiante.bonos.map(bono => (
                                                            <TableCell key={bono.id} sx={{ backgroundColor: 'lightblue' }} align="center">{bono.nota}</TableCell>
                                                        ))}
                                                        <TableCell align="center" sx={{ backgroundColor: 'LightGray' }} >{estudiante.definitiva}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

export default GradeShow;

